export default {
  notVatRegistered: '30062020-074554-4024',
  VATnumberLabel: '06122016-141440-8380',
};
